// Resolves a thrown error to the copy the user should see on 관리지침.
//
// SHCT-702 — this used to end in `defaultValue: err.message`, which published the server's own text
// whenever this app had no copy for the code. A server fault answers with `INTERNAL_ERROR`, which no
// per-feature guard listed, so a raw exception string could reach the operator. The shared resolver
// inverts the rule: show a message only when this app has copy for it, else the operation fallback.

import type { TFunction } from 'i18next';

import { resolveApiErrorMessage } from '@/shared/utils/api-error-message';

import { ManagementGuidelineApiError } from '../types/management-guidelines.types';

export function getGuidelineErrorMessage(
  err: unknown,
  t: TFunction,
  fallbackKey: string,
): string {
  const code = err instanceof ManagementGuidelineApiError ? err.code : null;
  return resolveApiErrorMessage(t, code, fallbackKey);
}
